import ReactGA from "react-ga";
import store from "../redux/store/index";

export class BaseService {
  constructor(base) {
    this.store = store;
    this.RGA = ReactGA;
    this.name = "Base";
    this.BASE_URL = process.env.REACT_APP_BASE_URL;
  }

  GA(action, id = null) {
    this.RGA.event({
      category: action,
      action: this.name,
      label: id
    });
  }
  createOrEdit(data, id) {
    if (id) return this.edit(data, id);
    return this.create(data);
  }

  create(data) {
    let self = this;
    return this.post(this.url, JSON.stringify(data)).then(function (response) {
      if (response.hasOwnProperty("error")) return response;
      self.GA("Create", response.id);
      return response;
    });
  }

  edit(data, id) {
    this.GA("Edit", id);

    return this.patch(this.getIdUrl(id), JSON.stringify(data));
  }

  deleteById(id) {
    this.GA("Delete", id);
    return this.delete(this.getIdUrl(id));
  }

  read() {
    return this.get(this.url);
  }

  readByID(id) {
    return this.get(this.getIdUrl(id));
  }
  get(url) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "GET",
      withCredentials: true,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    }).then(resp => resp.json());
  }

  getRaw(url) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "GET",
      withCredentials: true,
      headers: {
        "Accept": "text/plain",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    }).then(resp => resp);
  }

  getNotJson(url) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "GET",
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("id-tkn")}`
      }
    });
  }


  postNotJson(url, body) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "POST",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    });
  }

  post(url, body) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "POST",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("id-tkn")}`
      }
    }).then(resp => resp.json());
  }

  postBeta(url, body) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "POST",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("id-tkn")
      }
    }).then(resp => resp.body);
  }

  patch(url, body) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "PATCH",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    }).then(resp => resp.json());
  }

  put(url, body) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "PUT",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    }).then(resp => resp.json());
  }

  delete(url) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "DELETE",
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("id-tkn")
      }
    });
  }

  getUrl(filter, count = null) {
    let url = this.url;
    if (count) url += "/count";
    if (filter) {
      if (count) url += "?where=";
      else url += "?filter=";
      return url + JSON.stringify(filter);
    }
    return url;
  }

  getIdUrl(id, filter) {
    if (filter) {
      return this.url + "/" + id + "?filter=" + JSON.stringify(filter);
    }
    return this.url + "/" + id;
  }

  searchId(list, id) {
    return list.find(x => x.id === id);
  }
}

export default BaseService;
